<template>
<div class="directory"
     v-if="item">

  <sliceheadline :title="item.data.title"
                 :item="item">
    <div class="tools">
      <b-form-group v-if="allTypes.length > 1">
        <b-form-radio-group id="category-filter"
                            v-model="currentType"
                            :options="allTypes"
                            role="link"
                            buttons
                            @change="handleChange"
                            button-variant="outline-primary"
                            size="sm"
                            name="Category filter"></b-form-radio-group>
      </b-form-group>
      <b-form-group>
        <label for="filter"
               class="sr-only">Filter</label>
        <b-form-input v-model="needle"
                      id="filter"
                      placeholder="Filter"
                      @blur="getItems"
                      @keydown.native.enter="getItems" />
      </b-form-group>
      <b-button v-if="needle.length> 0"
                role="link"
                @click="reset"
                variant="outline">
        <Icon type="remove"></Icon>
      </b-button>
    </div>
  </sliceheadline>
  <DirectoryListings
      v-if="result"
      :items="sorted"
      :current-page="page"
      :total-rows="result.total_results_size"
      :per-page="pageSize"
      @page-change="setPage"
  />
</div>
</template>

<script>
import multisort from "multisort"
import DirectoryListings from "@/components/ui/DirectoryListings"
export default {
  name: "Directory",
  props: [ 'uid' ],
  components: {
    DirectoryListings
  },
  metaInfo() {
    return {
      title: this.item ? this.$prismic.asText(this.item.data.title) : "Loading...",
      link: [{rel: 'canonical', href: 'https://hungerfreeamerica.org'+ this.$route.fullPath}]
    };
  },
  mounted() {
    this.getContent()
  },
  data() {
    return {
      item: null,
      result: null,
      directories: [],
      currentType: null,
      page: 1,
      pageSize: 12,
      needle: ''
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.getContent()
        this.needle = ''
      }
    },
    'item': {
      immediate: true,
      handler() {
        this.currentType = this.uid
      }
    },
  },
  computed: {
    type() {
      return this.item && this.item.data.type ? this.item.data.type.toLowerCase().replace( " ", "_" ) : ''
    },
    allTypes() {
      if ( this.directories.length > 0 ) {

        let list = this.directories.map( a => {
          return {
            text: this.$prismic.richTextAsPlain( a.data.title ),
            value: a.uid,
            type: a.data.type
          }
        } )
        var criteria = [
          function( a ) {
            return a.type != 'All'
          }
        ];

        return multisort( list, criteria )
      }
      return []
    },
    types() {
      if ( this.type == 'all' ) {
        return this.directories.map( a => a.data.type.toLowerCase().replace( " ", "_" ) )
      } else {
        return [ this.type ]
      }
    },
    sorted() {
      let ar = this.result.results.map( a => {
        if ( a.data.release_date ) {
          return a
        } else {
          a.data.release_date = a.first_publication_date
          return a
        }
      } )

      var criteria = [
        '~data.pinned',
        '~data.release_date',
      ];

      return multisort( ar, criteria )
    }
  },
  methods: {
    getContent() {
      // this.getAllDocuments().then(documents => {
      //   console.log('All documents:', documents);
      // });
      this.$prismic.client.getByUID( 'directory', this.uid, {
        lang: this.language,
      } ).then( response => {
        if ( response ) {
          this.item = response

          this.getAllDirectories()
        }
      } );
    },
    getAllDirectories() {
      this.$prismic.client.query( [
        this.$prismic.Predicates.at( 'document.type', 'directory' ),
        this.$prismic.Predicates.at( 'my.directory.grouping', this.item.data.grouping ),
      ], {
        lang: this.language,
      } ).then( response => {
        this.directories = response.results
        this.getItems()
      } );
    },

    //I was just using this to export all the documents from prismic for a site audit.
   /* getAllDocuments() {
      return this.$prismic.client.query(
          [], // Empty predicates array gets all documents
          {
            lang: this.language,
            pageSize: 100, // Maximum page size
            orderings: '[document.first_publication_date desc]'
          }
      ).then(response => {
        let allDocuments = response.results;

        // If there are more pages, fetch them recursively
        if (response.next_page) {
          return this.getAllDocumentsPaginated(allDocuments, response.next_page);
        }

        return allDocuments;
      });
    },

// Helper method to handle pagination
    getAllDocumentsPaginated(existingDocs, nextPageUrl) {
      return this.$prismic.client.query(
          [],
          {
            lang: this.language,
            pageSize: 100,
            page: this.getPageFromUrl(nextPageUrl)
          }
      ).then(response => {
        const combinedDocs = [...existingDocs, ...response.results];

        if (response.next_page) {
          return this.getAllDocumentsPaginated(combinedDocs, response.next_page);
        }

        return combinedDocs;
      });
    },

// Helper to extract page number from URL
    getPageFromUrl(url) {
      const urlParams = new URLSearchParams(url.split('?')[1]);
      return parseInt(urlParams.get('page')) || 1;
    },*/

    getItems() {
      let search = this.needle ? this.$prismic.Predicates.fulltext( 'document', this.needle ) : null
      this.$prismic.client.query( [
        this.$prismic.Predicates.any( 'document.type', this.types ), search

      ], {
        orderings: '[ document.first_publication_date desc]',
        page: this.page,
        pageSize: this.pageSize,
      } ).then( ( response ) => {
        this.result = response
      } );
    },

    setPage(newPage){
      this.page = newPage;
      this.getItems()
    },

    setPageSize(pageSize){
      this.pageSize = pageSize;
      this.getItems()
    },

    handleChange( val ) {
      this.$router.push( `/${this.language}/directory/${val}` )
    },
    reset() {
      this.needle = ''
      this.getItems()
    }

  }
};
</script>
<style scoped lang="scss">
.directory {
    display: grid;
    grid-gap: 5rem;

    .tools {
        @include grid-h;
        justify-content: space-between;
        align-items: center;
        align-content: center;

        .form-group {
            margin: 0;
        }

        .mobile & {
            grid-template-rows: 1fr 1fr;
        }
      ::v-deep(.btn-outline-primary.active),
      ::v-deep(.btn-outline-primary:active),
        /* Bootstrap 5-style markup (bootstrap-vue-next): */
      ::v-deep(.btn-check:checked + .btn-outline-primary) {
        color: #fff !important;
      }

    }
  input{ color: inherit;}
}
</style>
